import React from "react";
import Competitors from "../../components/Competitors";
export default function Index() {
  return (
    <div>
      <Competitors />
    </div>
  );
}
